import { getFetch, postFetchWithBody, postFetchWithToken } from "../../utils/fetch";

async function getProject({ page = "page=1", term = "" }) {
  const data = await getFetch(`/Project?term=${term}&${page}`);
  if (data.status !== "error") {
    return {
      status: "success",
      message: data,
    };
  } else {
    return {
      status: data.status,
      message: "خطا در اتصال به سرور!",
    };
  }
}
async function storeProject(form) {
  if (form.get('title') === '') {
    return {
      status: 'error',
      message: 'عنوان الزامی است!',
    }
  }

  const res = await postFetchWithToken("/Project/store", form);
  if(res.status !== 'error'){
    return {
      status:'success',
      message:'پروژه با موفقیت ایجاد شد'
    }
  }else{
    return {
      status:res.status,
      message:res.message
    }
  }
}
async function deleteProject(id) {
  const res = await postFetchWithBody(`/Project/delete`, { id: id });
  if (res.status !== "error") {
    return {
      status: "success",
      message: res,
    };
  } else {
    return {
      status: res.status,
      message: "خطا در اتصال به سرور!",
    };
  }
}
export { getProject, storeProject , deleteProject };
